import { TeamResponse } from 'lib/teams';
import AccountPlanRow from 'components/account/AccountPlanRow';

interface ListProps {
  items: TeamResponse[];
}

const PlanList = ({ items }: ListProps) => (
  <div style={{ minHeight: 120 }}>
    {items.map((team, index) => (
      <AccountPlanRow
        key={team.ownerId}
        team={team}
        divider={index < items.length - 1}
      />
    ))}
  </div>
);

export default PlanList;
